export const TRANSFER_LOADING = "TRANSFER_LOADING";
export const TRANSFER_RESET = "TRANSFER_RESET";
export const GET_TRANSFER = "GET_TRANSFER";
export const GET_TRANSFER_SUCCESS = "GET_TRANSFER_SUCCESS";
export const GET_TRANSFER_FAIL = "GET_TRANSFER_FAIL";
export const DELETE_TRANSFER = "DELETE_TRANSFER"
export const DELETE_TRANSFER_SUCCESS = "DELETE_TRANSFER_SUCCESS"
export const DELETE_TRANSFER_FAIL = "DELETE_TRANSFER_FAIL"
export const UPDATE_TRANSFER = "UPDATE_TRANSFER"
export const UPDATE_TRANSFER_SUCCESS = "UPDATE_TRANSFER_SUCCESS"
export const UPDATE_TRANSFER_FAIL = "UPDATE_TRANSFER_FAIL"
export const ADD_NEW_TRANSFER = "ADD_NEW_TRANSFER"
export const ADD_TRANSFER_SUCCESS = "ADD_TRANSFER_SUCCESS"
export const ADD_TRANSFER_FAIL = "ADD_TRANSFER_FAIL"